/** The single issue that still routes the user toward applying for the unit. */
const APARTMENT_ONLY_ISSUE = 'Unprofessional agent';
/**
 * Decides which success screen to show after feedback is submitted.
 *
 * - "apartment" → the tour went well enough to keep nudging this unit, so we
 *   surface the property again with an Apply CTA. This happens on a 5-star
 *   rating, or when the only complaint was an unprofessional agent (the unit
 *   itself was fine).
 * - "generic" → any other feedback; we send the user back to browsing.
 */
export function getTourFeedbackSuccessVariant({ rating, issues, }) {
    if (rating === 5)
        return 'apartment';
    if (issues.length === 1 && issues[0] === APARTMENT_ONLY_ISSUE)
        return 'apartment';
    return 'generic';
}
